import React from 'react';
import './WhoItsForSection.css';

const WhoItsForSection: React.FC = () => {
  return (
    <section className="who-its-for-section">
      <h2>Use Cases</h2>
      <div className="use-cases-grid">
        <div className="use-case-item">
          <div className="use-case-icon-placeholder"></div>
          <h3>Restaurants</h3>
          <p>Ensure consistent food quality, hygiene standards, and service excellence across all shifts and locations.</p>
        </div>
        <div className="use-case-item">
          <div className="use-case-icon-placeholder"></div>
          <h3>Cleaning Services</h3>
          <p>Maintain high cleaning standards, manage schedules efficiently, and ensure client satisfaction.</p>
        </div>
      </div>
    </section>
  );
};

export default WhoItsForSection;
